<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:36:18
 * @LastEditTime: 2019-08-29 15:04:05
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div style="position:  relative;">
        <van-nav-bar :title="title" :left-text="leftText" :left-arrow="leftArrow && !isShowOverlay" @click-left="leftClick" :right-text="rightText" @click-right="rightClick">
            <template slot="title">
                <slot name="title"></slot>
            </template>
            <template slot="right" v-if="!isShowOverlay">
                <slot name="right"></slot>
            </template>
        </van-nav-bar>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isShowOverlay: false,
            watcher: null
        };
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        rightText: {
            type: String,
            default: ''
        },
        leftArrow: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        leftText: function() {
            return this.leftArrow && !this.isShowOverlay ? '' : '';
        }
    },
    esvReady: function() {
    },
    esvShow: function() {
        this.init();
    },
    beforeDestroy: function() {
        this.watcher && this.watcher.disconnect();
    },
    destroyed: function() {
        this.watcher = null;
    },
    methods: {
        init() {
            let self = this;
            let test = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            if (test) {
                if (self.watcher) {
                    self.watcher.disconnect();
                    self.watcher = null;
                }
                self.watcher = new MutationObserver(records => {
                    if (records.length > 0 && !self.ESVBase.isEmpty(records[0].target) && records[0].target.className === 'van-overflow-hidden') {
                        self.isShowOverlay = true;
                    } else {
                        self.isShowOverlay = false;
                    }
                });
                self.watcher.observe(document.getElementsByTagName('body')[0], {
                    attributes: true,
                    attributesFilter: ['class']
                });
            }
        },
        rightClick() { // 菜单被点击
            this.$emit('click-right');
        },
        leftClick() {
            if (document.getElementsByTagName('body')[0].className !== 'van-overflow-hidden') {
                window.rootVue.$children[0].$options.esvBack.call(window.rootVue.$children[0], (isReturn) => {
                    if (isReturn) {
                        window.rootVue.$children[0].esvReloadPage();
                    }
                });
            }
        }
    }
};

</script>
<style scoped>
</style>
